/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.16.0
 * @since 1.15.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../../theme';

export const OnboardingModalStyled = styled.div.attrs({
    className: 'onboarding-modal',
})`
    .onboarding-modal__text {
        margin-bottom: 32px;
    }

    .onboarding-modal__control:not(:last-child) {
        margin-bottom: 16px;
    }

    a {
        ${fonts.textLink};
        outline: none;
        text-decoration: none;
        border-bottom-color: ${colors.linkDefaultColorHover};
        border-bottom-width: 1px;

        &:hover, &:focus {
            border-bottom-style: solid;
        }
    }
`;

export const OnboardingModalImgStyled = styled.img.attrs({
    className: 'onboarding-modal__image',
})`
    margin-bottom: 16px;
`;

export const OnboardingModalLinkStyled = styled.div.attrs({
    className: 'onboarding-modal__link',
})`
    margin-top: 16px;
`;
